<template>
	<v-card>
		<v-card-title>Attachment Meta Data</v-card-title>
		
		<AddManyTable :items="rows" :columns="cols"></AddManyTable>
		<v-card-actions class="text-right">
			<v-btn class="ml-2  mb-3" color="green" dark  @click="updateMeta">Save Meta Data</v-btn> 
		</v-card-actions>
	</v-card>
</template>


<script>
	import AddManyTable from "../tools/AddManyTable.vue"
	import {
		updateMetaData, 
		getMetaData
	} from "../../assets/storageFunctions.js";
	export default{
		name: "FileMeta",
		props: {
			exists: { type: Boolean },
			filePath: {type: String }
		},
		components: {
			AddManyTable: AddManyTable
		},
		data: () => {
			return  {
				meta: {},				
				rows: [],
				cols: [
					{type: "text", name: "Key", value: "key"},
					{type: "text", name: "Value", value: "value"},
				],
				error: false
			}
		},
		methods: {
			updateMeta(){
				const self = this;
				self.rows.forEach( row => {
					self.meta[row.key] = row.value;
				})
				updateMetaData( {customMetadata: self.meta}, self.filePath ).then( meta => {
					self.meta = meta;
					self.updated = true;
					this.$emit("complete", self.meta )
				})
				
			},
		},
		created(){
			const self = this;
			if( self.exists ){
				getMetaData(self.filePath).then( meta => {
					if(meta.customMetadata){
						Object.keys(meta.customMetadata).forEach( key => {
							self.rows.push({key: key, value: meta.customMetadata[key]})
						})
					}
				})
			}	
		}
	}
</script>